import { G2_ICONS } from '../data/icons.js';
import { pageNumbers } from '../lib/pagination.js';

export function renderPager({ id, page, totalPages, from, to, total, label = 'itens', hrefFor }) {
  const nums = pageNumbers(page, totalPages);
  const href = (n) => (hrefFor ? hrefFor(n) : '#');
  const prev = page <= 1
    ? `<span class="pager-btn" aria-disabled="true" aria-label="Página anterior">${G2_ICONS.left}</span>`
    : `<a href="${href(page - 1)}" class="pager-btn" data-pager="${id}" data-page="${page - 1}" aria-label="Página anterior">${G2_ICONS.left}</a>`;
  const next = page >= totalPages
    ? `<span class="pager-btn" aria-disabled="true" aria-label="Próxima página">${G2_ICONS.right}</span>`
    : `<a href="${href(page + 1)}" class="pager-btn" data-pager="${id}" data-page="${page + 1}" aria-label="Próxima página">${G2_ICONS.right}</a>`;
  const numsHtml = nums.map((n) => n === '…'
    ? `<span class="pager-ellipsis" aria-hidden="true">…</span>`
    : `<a href="${href(n)}" class="pager-btn${n === page ? ' on' : ''}" data-pager="${id}" data-page="${n}" aria-label="Página ${n}" aria-current="${n === page ? 'page' : 'false'}">${n}</a>`
  ).join('');

  return `
  <nav class="pager" aria-label="Paginação">
    <span class="pager-info">${from}–${to} de ${total} ${label}</span>
    <div class="pager-btns">
      ${prev}${numsHtml}${next}
    </div>
  </nav>`;
}
